import { combineReducers } from "redux";

import list from "./List/reducer";
import view from "./View/reducer";

const eodReportsLogsReducer = combineReducers({
  list,
  view,
});

export default eodReportsLogsReducer;
